import { AxiosError } from 'axios'
import React from 'react'

import { css } from 'design'

import { ErrorMessage } from '../../controls/errors/error_message'
import { WidgetLogo } from '../../images'
import { ErrorDetail } from './error_detail'

type ErrorBoundaryProps = {
  children: any
  liveChatVersion?: boolean
}

type ErrorBoundaryState = {
  error: any | undefined
}

export class ErrorBoundary extends React.PureComponent<
  ErrorBoundaryProps,
  ErrorBoundaryState
> {
  constructor(props: ErrorBoundaryProps) {
    super(props)
    this.state = { error: undefined }
    // eslint-disable-next-line
    // @ts-ignore
    this.widgetLogoElement = null
    // eslint-disable-next-line
    // @ts-ignore
    this.setWidgetLogoElement = (element: any) => {
      // eslint-disable-next-line
      // @ts-ignore
      this.widgetLogoElement = element
    }
  }

  static getDerivedStateFromError(error: Error) {
    return { error: error }
  }

  componentDidCatch(error: Error, errorInfo: React.ErrorInfo) {
    ErrorBoundary.logErrorToMyService(error, errorInfo)
  }

  static logErrorToMyService(error: Error, ...errorInfo: any) {
    try {
      // eslint-disable-next-line no-console
      console.error(error, errorInfo)

      // eslint-disable-next-line
      // @ts-ignore
      const { isAxiosError, response } = error
      if (isAxiosError) {
        if (!response?.status) {
          // network error
          return
        }
        error = new Error(
          JSON.stringify({
            message: (error as AxiosError).message,
            baseURL: (error as AxiosError).config.baseURL,
            url: (error as AxiosError).config.url,
            method: (error as AxiosError).config.method,
            response: {
              status: (error as AxiosError).response?.status,
              statusText: (error as AxiosError).response?.statusText,
              data: (error as AxiosError).response?.data,
            },
          }),
        )
      }

      // const commitHash = document.documentElement.dataset.commitHash
      // if (commitHash) {
      //   try {
      //     error.message = `commitHash: ${commitHash}: ${error.message}`
      //   } catch {
      //     // do nothing
      //   }
      // }

      // If an error is not thrown, it will not have a stack trace in some browsers
      try {
        throw error
      } catch (e) {
        // newrelic js included in page header by ruby gem
        // eslint-disable-next-line
        // @ts-ignore
        window.newrelic?.noticeError(e, errorInfo)
      }
    } catch (logError) {
      // eslint-disable-next-line no-console
      console.error(logError)
    }
  }

  render() {
    const { error } = this.state
    if (error) {
      if (this.props.liveChatVersion) {
        return (
          <>
            <div
              // eslint-disable-next-line
              // @ts-ignore
              ref={this.setWidgetLogoElement}
              className={widgetLogoContainerStyles()}
            >
              <WidgetLogo role={'button'} width={65} height={65} />
            </div>
            <ErrorMessage
              // eslint-disable-next-line
              // @ts-ignore
              element={this.widgetLogoElement}
            >
              <span>
                An error occurred.
                <br />
                Please refresh the page.
              </span>
            </ErrorMessage>
          </>
        )
      } else {
        return <ErrorDetail error={error} />
      }
    }

    return this.props.children
  }
}

export default ErrorBoundary

const widgetLogoContainerStyles = css({
  position: 'absolute !important',
  bottom: 0,
  right: 0,
  marginRight: 10,
})
